import React, { useState, useEffect, useRef } from "react";
import VanillaTilt from "vanilla-tilt";
import "./Products.css";

const products = [
  {
    name: "Bottoming Tap",
    image: "/Products/Bottoming-Taps.jpg1.webp",
    features: [
      "Bottoming taps are not fabricated with a narrowing end because it is primarily for threading the base of its reach.",
      "Best suited for threading blind holes.",
      "Ensures full thread depth at the bottom of a hole.",
      "Should be used after taper tap for best results.",
      "Ideal for applications requiring precise and complete internal threads.",
    ],
  },
  {
    name: "Extension Tap",
    image: "/products/Extension-Taps.jpg.webp",
    features: [
      "This type of tap has extended shanks.",
      "Designed specifically to reach very deep holes.",
      "Also known as long shank taps due to their extended length.",
      "Ideal for applications where standard taps cannot reach.",
      "Maintains thread quality even in hard-to-access areas.",
    ],
  },
  {
    name: "Forming Tap",
    image: "/products/Forming-Taps.jpeg.webp",
    features: [
      "Forming taps displace metal to create thread shapes instead of cutting it.",
      "Suitable only for malleable metals like aluminum or mild steel.",
      "Produces stronger and tougher threads compared to cutting taps.",
      "No chip formation during the threading process.",
      "Ideal for high-strength internal threads in ductile materials.",
    ],
  },
  {
    name: "Interrupted Thread Tap",
    image: "/products/Interrupted-Thread-Taps.jpeg.webp",
    features: [
      "Features a tooth for every other thread, reducing cutting load.",
      "Allows smooth chip evacuation due to its unique design.",
      "Minimizes tool wear and improves tap life in tough materials.",
      "Similar to power taps in enabling efficient chip exit.",
      "Ideal for deep or blind hole tapping in materials prone to chip packing.",
    ],
  },
  {
    name: "Gear Hob Cutter",
    image: "/products/Gear-hob.jpg",
    features: [
      "Precision cutting tool essential for manufacturing spur and helical gears.",
      "Supports finishing operations like pre-shaving and pre-grinding.",
      "Accommodates various gear profiles such as convex corners, half-top teeth, and top cutting.",
      "Available in hole-type (central bore) and rod-type (integral shank) designs.",
      "Offered in single-start and multi-start configurations for enhanced productivity.",
      "Available in accuracy grades ranging from A to AAA, with AAA being the highest precision.",
    ],
  },
  {
    name: "Involute Spline Hob",
    image: "/products/Involute-spline-hob.jpg",
    features: [
      "Precision cutting tool for producing splined shafts and internal splines.",
      "Used extensively in automotive, aerospace, and industrial gear systems.",
      "Supports various global involute spline standards like ANSI, DIN, and BS.",
      "Capable of generating both internal and external splines with high accuracy.",
      "Available in single-start and multi-start configurations for improved productivity.",
      "Available in different pressure angles, modules, and accuracy grades.",
    ],
  },
  {
    name: "Pipe Tap",
    image: "/products/Pipe-Taps.jpg.webp",
    features: [
      "Specialized tool used for cutting internal pipe threads.",
      "Available in two types: straight pipe taps and tapered pipe taps.",
      "Straight pipe taps are used when the thread needs to remain parallel.",
      "Tapered pipe taps are ideal when a tight, leak-proof fit is required.",
      "Commonly used in plumbing, hydraulic, and pneumatic applications.",
      "Ensures accurate and reliable thread engagement for pipe fittings.",
      "Made from high-speed steel for durability and precision.",
      "Compatible with standard thread forms like NPT, BSP, and more.",
    ],
  },
  {
    name: "Plug Tap",
    image: "/products/Plug-Taps.jpg.webp",
    features: [
      "Plug taps are tapered with 3 to 5 threads at the tip.",
      "Provide a balance between thread engagement and ease of starting.",
      "Commonly used as the second tap in a three-tap set (Taper, Plug, Bottoming).",
      "Sometimes referred to as the 'second tap' or even 'bottoming tap' in certain regions.",
      "Ideal for general-purpose threading of through or blind holes.",
      "Offers smoother thread formation compared to bottoming taps.",
      "Compatible with a wide range of materials like aluminum, steel, and brass.",
      "Manufactured from high-speed steel for durability and accuracy.",
    ],
  },
  {
    name: "Punch Tap",
    image: "/products/Punch-Taps.jpg.webp",
    features: [
      "Made from durable HSSE-PM alloy for extended tool life.",
      "Creates threads in a single rapid operation using helical flutes.",
      "Features two flutes at 180° with a helical curve to guide the tap.",
      "Punches into a pre-drilled hole and forms threads via cold forming.",
      "Reduces threading time by up to 75% with minimal energy usage.",
      "Threading involves simultaneous feed and rotation for precision.",
      "Ideal for high-speed, high-efficiency industrial thread forming.",
    ],
  },
  {
    name: "Spiral Flute Taps",
    image: "/products/Spiral-Flute-Taps-1536x218.jpg.webp",
    features: [
      "Designed with open spirals for effective chip evacuation.",
      "Ideal for threading blind holes and interrupted cuts.",
      "Provides excellent control during tapping operations.",
      "Offers better performance than traditional hand taps.",
      "Minimizes chip clogging in deep or closed-end holes.",
      "Ensures cleaner threads and improved tool life.",
      "Commonly used in high-precision applications.",
    ],
  },
  {
    name: "Taper Taps",
    image: "/products/Taper-Taps.webp",
    features: [
      "Ideal for initiating thread cutting operations.",
      "Designed with gradual taper to ease entry into material.",
      "Simplifies threading by reducing cutting resistance.",
      "Widely available in various taper types.",
      "Ensures smoother starts and accurate thread alignment.",
      "Commonly used for through holes and hand tapping.",
      "Compatible with a broad range of materials.",
    ],
  },
];

const Products = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const tiltRef = useRef(null);

  useEffect(() => {
    const tiltEl = tiltRef.current;

    if (selectedImage && tiltEl) {
      VanillaTilt.init(tiltEl, {
        max: 15,
        speed: 400,
        glare: true,
        "max-glare": 0.3,
        gyroscope: true,
      });
    }

    return () => {
      if (tiltEl && tiltEl.vanillaTilt) {
        tiltEl.vanillaTilt.destroy();
      }
    };
  }, [selectedImage]);

  return (
    <div className="products-section">
      <h2 className="section-title">Our Products</h2>
      <div className="products-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <div
              className="tilt-image"
              onClick={() => setSelectedImage(product.image)}
            >
              <img
                src={product.image}
                alt={product.name}
                className="product-image"
              />
            </div>

            <h3 className="product-title">{product.name}</h3>
            <ul className="product-features">
              {product.features.map((feature, i) => (
                <li key={i}>• {feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {selectedImage && (
        <div
          className="fullscreen-modal"
          onClick={() => setSelectedImage(null)}
        >
          <div className="fullscreen-content">
            <img
              ref={tiltRef}
              src={selectedImage}
              alt="Zoomed product"
              className="fullscreen-image"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Products;
